import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  card: null,
  toastMessage: null,
}
const setPinSlice = createSlice({
  name: 'setPin',
  initialState,
  reducers: {
    initSetPin(state, action) {
      const { card } = action.payload
      state.card = card
    },
    setToastMessage(state, action) {
      state.toastMessage = action.payload?.toastMessage
    },
    clearToastMessage(state) {
      state.toastMessage = null
    },
  },
})

export const selectToastMessage = (state) => state.setPin?.toastMessage
export const selectCardName = (state) => state.setPin.card?.metadata?.shortProductName
export const selectCardId = (state) => state.setPin.card?.cardId

export const { initSetPin, setToastMessage, clearToastMessage } = setPinSlice.actions

export default setPinSlice.reducer
